import { policyContents } from 'bundles/lp/chat/policyContents';

declare global {
  interface Window {
    agriNaviPolicyContents: typeof policyContents;
  }
}

window.agriNaviPolicyContents = policyContents;
